import React from "react";
import { fmtSASTDate, fmtZAR } from "@/lib/api";

const statusStyles = {
  active: "bg-[#00C853]/10 text-[#00C853] border-[#00C853]/30",
  partially_redeemed: "bg-[#00C4B4]/10 text-[#00C4B4] border-[#00C4B4]/30",
  fully_redeemed: "bg-gray-100 text-gray-500 border-gray-200",
  expired: "bg-orange-100 text-orange-700 border-orange-200",
  cancelled: "bg-red-50 text-red-700 border-red-200",
  suspended: "bg-yellow-50 text-yellow-700 border-yellow-200",
};

export function VoucherCard({ voucher, onCopy, onClick }) {
  const used = voucher.original_amount > 0 ? Math.min(100, Math.round(((voucher.original_amount - voucher.balance) / voucher.original_amount) * 100)) : 0;
  const ss = statusStyles[voucher.status] || statusStyles.active;
  return (
    <div
      data-testid={`voucher-card-${voucher.id}`}
      onClick={onClick}
      className="fv-voucher p-6 cursor-pointer hover:-translate-y-0.5 transition-transform"
    >
      <div className="flex items-start justify-between">
        <div>
          <p className="text-[10px] uppercase tracking-[0.2em] text-[#00C4B4] font-bold">Voucher</p>
          <p className="font-mono text-lg text-[#0A2540] mt-1">{voucher.pin_masked}</p>
        </div>
        <span data-testid={`voucher-status-${voucher.id}`} className={`text-[10px] uppercase tracking-widest px-2 py-1 rounded-full border ${ss}`}>
          {voucher.status.replace("_", " ")}
        </span>
      </div>
      <div className="mt-5">
        <p className="font-display text-3xl font-bold text-[#0A2540]">{fmtZAR(voucher.balance)}</p>
        <p className="text-xs text-[#666666]">of {fmtZAR(voucher.original_amount)} original</p>
      </div>
      <div className="mt-4 h-1.5 w-full rounded-full bg-[#F8F9FA] overflow-hidden">
        <div className="h-full bg-[#00C4B4]" style={{ width: `${100 - used}%` }} />
      </div>
      <div className="mt-4 flex items-center justify-between text-[11px] text-[#666666]">
        <span className="uppercase tracking-wider">{voucher.intended_service || "general"}</span>
        <span>Exp {fmtSASTDate(voucher.expires_at)}</span>
      </div>
    </div>
  );
}
